import { Link } from '@reach/router';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import MainWrapper from '../Utils/MainWrapper';

import styles from './MainPage.module.scss';

let BASE_PATH = process.env.REACT_APP_BASE_PATH;
if (BASE_PATH[BASE_PATH.length - 1] === '/') {
  BASE_PATH = BASE_PATH.substring(0, BASE_PATH.length - 1);
}

function Tile({
  num, name, path, encrypted,
}) {
  const { t } = useTranslation();

  const tileContent = (
    <div className={styles.cardContent}>
      <span className={styles.itemsNumber}>{num}</span>
      <span className={styles.cardName}>{name}</span>
      {
        encrypted
          ? (
            <span className={styles.encryptedMark}>
              <span className={styles.tooltipText}>{t('Information is encrypted')}</span>
            </span>
          )
          : null
      }
    </div>
  );

  return (
    <div className={styles.cardContainer}>
      {
        path && !encrypted
          ? (
            <Link
              to={`${BASE_PATH}/${path}`}
              className={`${styles.card} ${styles.expandable}`}
            >
              {tileContent}
            </Link>
          )
          : <div className={`${styles.card}`}>{tileContent}</div>
      }
    </div>
  );
}

Tile.propTypes = {
  num: PropTypes.number,
  name: PropTypes.string.isRequired,
  path: PropTypes.string,
  encrypted: PropTypes.bool.isRequired,
};

Tile.defaultProps = {
  num: null,
  path: '',
};

function ResetLink() {
  const { t } = useTranslation();

  return (
    <div className={styles.resetLink}>
      <h1>{t('Your synchronized content')}</h1>
      {t('Do not remember your key synchronization password (passphrase)? ')}
      <Link to="reset" className={styles.resetLink}>{t('Reset Passphrase')}</Link>
    </div>
  );
}

function MainPage({ counters }) {
  const { t } = useTranslation();

  return (
    <MainWrapper className={styles.mainWrapperEmptyPage}>
      <ResetLink />
      <div className={styles.container}>
        <Tile
          num={counters.bookmarks ? counters.bookmarks.count : null}
          name={t('Bookmarks')}
          path="bookmarks"
          encrypted={Boolean(counters.bookmarks && counters.bookmarks.encrypted)}
        />
        <Tile
          num={counters.speeddials ? counters.speeddials.count : null}
          name={t('Speed Dials')}
          path="speeddials"
          encrypted={Boolean(counters.speeddials && counters.speeddials.encrypted)}
        />
        <Tile
          num={counters.tabs ? counters.tabs.count : null}
          name={t('Open tabs')}
          path="tabs"
          encrypted={Boolean(counters.tabs && counters.tabs.encrypted)}
        />
        <Tile num={counters.devices} name={t('Devices')} path="devices" encrypted={false} />
        <Tile
          num={counters.history ? counters.history.count : null}
          name={t('History')}
          path="history"
          encrypted={Boolean(counters.history && counters.history.encrypted)}
        />
        <Tile num={counters.passwords} name={t('Passwords')} encrypted />
        <Tile num={counters.preferences} name={t('Preferences')} encrypted={false} />
        <div className={styles.cardContainer} />
      </div>
    </MainWrapper>
  );
}

const counterShape = PropTypes.shape({
  count: PropTypes.number.isRequired,
  encrypted: PropTypes.bool.isRequired,
});

MainPage.propTypes = {
  counters: PropTypes.shape({
    tabs: counterShape,
    history: counterShape,
    devices: PropTypes.number,
    preferences: PropTypes.number,
    passwords: PropTypes.number,
    speeddials: counterShape,
    bookmarks: counterShape,
  }).isRequired,
};

export default MainPage;
